export default function getDayDateFactory(ajax, getSession) {
  return async function getDayDate(Id, day, method, token) {
    return ajax({ resource: `trips/treks/${Id}/days/${day}`, method });
  };
}



// WEBPACK FOOTER //
// ./src/services/getDayData.js